import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { Tag } from '../../tags/models';

@Injectable({
    providedIn: 'root'
})
export class PartnerTagsService {
    constructor(private httpService: JsonHttpService) { }

    getAllPartnerTags(partnerId: number): Promise<Tag[]> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.get('/api/partners/tags/get-tags-for-partner', options).toPromise();
    }

    setAllPartnerTags(partnerId: number, tagIds: number[]): Promise<any> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.post('/api/partners/tags/set-tags-on-partner', tagIds, options).toPromise();
    }
}
